import { render, staticRenderFns } from "./fashion-middle.vue?vue&type=template&id=37667326&scoped=true"
import script from "./fashion-middle.vue?vue&type=script&lang=js"
export * from "./fashion-middle.vue?vue&type=script&lang=js"
import style0 from "./fashion-middle.vue?vue&type=style&index=0&id=37667326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37667326",
  null
  
)

export default component.exports